import { Accordion } from "./components/Accordion"
import { AircraftHead } from "./components/AircraftHead"
import { Carousel } from "./components/Carousel"
import { docHeight } from "./utils/helpers"
import { Expandable } from "./components/Expandable"
import { Menu } from "./components/Menu"
import { Modal } from "./components/Modal"
import { ParallaxGrid } from "./components/ParallaxGrid"
import { PopupBanner } from "./components/PopupBanner"
import { Search } from "./components/Search"
import { Takeover } from "./components/Takeover"
import { Slider } from "./components/Slider"
import { Tabs } from "./components/Tabs"
import { videoInline } from "./modifications/playsinline"
import { detailsToggle } from "./modifications/detailsToggle"
import { tables } from "./modifications/tables"
import { RegisterVideoPlayer } from "./components/VideoContentType/VideoPlayer"
import { fun } from "./components/Fun"
import { MissileTargeting } from "./components/MissileTargeting"

// Import JS
Accordion()
AircraftHead()
Carousel()
docHeight()
Expandable()
Menu()
Modal()
ParallaxGrid()
PopupBanner()
Search()
Takeover()
Slider()
Tabs()
videoInline()
detailsToggle()
tables()
RegisterVideoPlayer()
fun()
MissileTargeting()
